import ColumnsService from '@/services/columns';
import _ from 'lodash';
import { GENERAL_PRESET } from '@/services/constants/report';

const omitReportColumns = (data, omitColumns) => Object.entries(data).reduce((acc, [key, value]) => {
  acc[key] = {
    ...(value as any),
    columns: (value as any).columns.filter(column => !omitColumns.includes(column)),
    width: _.omit((value as any).width, omitColumns)
  }
  return acc
}, {})

const serverFormatColumnsToLocal = (store,data)=>{
  return data.reduce((acc, contextInstance) => {
    const { context, order } = contextInstance;
    const {width, columns, totalType} = contextInstance.columns.reduce((acc,{ name, width, totalType })=>{
      acc.columns.push(name)
      acc.width[name] = width;
      
      if(totalType){
        acc.totalType[name]  = totalType;
      }
      return acc;
    },{columns:[],width:{},totalType:{}})

    acc[context] = { 
      width, 
      columns, 
      order,
      context,
      totalType
    }

    return acc
  }, {..._.cloneDeep(store.getters.getDefaultColumns)})
}

export default {
  setSavedColumns: (store, presets) => {
    const presetsList = []
    const preparedColumnSettings = presets.reduce((presetsAcc, preset)=>{
      const presetId = preset.id || GENERAL_PRESET
      const presetName = preset.name
        presetsList.push(JSON.stringify({
          presetId,
          presetName
        }))
      presetsAcc[presetId] = serverFormatColumnsToLocal(store,preset.settings)

      return presetsAcc
    },{})
    store.commit('setSavedColumns', preparedColumnSettings)

    if(!store.state.reportColumns.savedColumns[store.state.report.activePreset]){
      store.commit('setActivePreset', GENERAL_PRESET)
    }
    store.commit('setPresetsInfo', [...new Set(presetsList)].map(item=>JSON.parse(item)) )
  },
  setGroupsColumns: (store, groups) => {
    const preparedGroupsColumnSettings = groups.reduce((acc,groupInstance,index)=>{
        const {name, isOpened, columns,groupId} = groupInstance;
        acc.groups[groupInstance.groupId]={
          groupId,
          index,
          name,
          isOpened
        }
        columns.forEach((column,index)=>{
          acc.columns[column]={
            groupId,
            index
          }
        })
        return acc;
      },{groups:{},columns:{}})

    store.commit('setGroupsColumns', preparedGroupsColumnSettings)
  },
  patchSavedColumns: (store, { presetId, presetDataServerFormat }) => {
    store.commit('updatePreset', {
      presetId,
      presetData: {
        ...store.getters.savedColumnsInCurentPreset,
        ...serverFormatColumnsToLocal(store,presetDataServerFormat)
      }
    })
  },
  patchWidth: (store, { contexts, columnName, width }) => {
    const savedColumns = store.getters.savedColumnsInCurentPreset
    const preparedColumnSettings = contexts.reduce((acc, context) => {
      acc[context] = _.set(savedColumns[context], ['width', columnName], width)
      return acc
    }, _.cloneDeep(savedColumns))

    store.commit('updatePreset', {
      presetId: store.state.report.activePreset,
      presetData: preparedColumnSettings
    })
  },
  patchOrder: (store, order) => {
    const { user: { independentColumnSettingsEnabled } } = store.state;
    const { dimensions } = store.state.reportColumns
    const savedColumns = store.getters.savedColumnsInCurentPreset

    const getPreparedColumns = (savedColumns) => {
      let contexts = [ColumnsService.type]

      if(!independentColumnSettingsEnabled) {
        contexts = _.uniq([
          ...contexts,
          ...Object.keys(dimensions)
            .filter(key => _.get(savedColumns, [key, 'columns'], []).includes(order.orderBy))
        ])
      }

      return contexts.reduce((acc, context) => {
        acc[context] = {
          ...savedColumns[context],
          order,
        }

        return acc
      }, _.cloneDeep(savedColumns))
    }

    if (store.state.table.activeTab) {
      store.commit('setActiveReportColumns', { columns: getPreparedColumns(store.getters.getColumns) })
      return
    }

    store.commit('updatePreset', {
      presetId: store.state.report.activePreset,
      presetData: getPreparedColumns(savedColumns)
    })

  },
  omitColumns: (store, omitColumns) => {
    const { user: { independentColumnSettingsEnabled } } = store.state;
    const { dimensions, savedColumns } = store.state.reportColumns

    let contexts = ColumnsService.type ? [ColumnsService.type] : Object.keys(dimensions)

    if(ColumnsService.type && !independentColumnSettingsEnabled) {
      contexts = _.uniq([
        ...contexts,
        ...Object.keys(dimensions)
      ])
    }

    const preparedColumnSettings = contexts.reduce((acc, context) => {
      acc[context] = {
        ...savedColumns[context],
        columns: savedColumns[context].columns.filter(column => !omitColumns.includes(column)),
        width: _.omit(savedColumns[context].width, omitColumns)
      }

      return acc
    }, _.cloneDeep(savedColumns))

    store.commit('updatePreset', {
      presetId: store.state.report.activePreset,
      presetData: preparedColumnSettings
    })

  },

  omitReportsColumns: (store, omitColumns) => {
    const preparedColumnSettings = omitReportColumns(store.getters.savedColumnsInCurentPreset, omitColumns)
    store.commit('updatePreset', {
      presetId: store.state.report.activePreset,
      presetData: preparedColumnSettings
    })

    store.state.table.activeReports.forEach((report) => {
      const columns = omitReportColumns(report.state.savedColumns, omitColumns)
      store.commit('setActiveReportColumns', { columns, id: report.tabId })
    })
  },

};
